import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { AbstractSTVPlatformConfig } from 'tag/ts/tag/player/stv/configs/platforms/AbstractSTVPlatformConfig';
export class SamsungTizen extends AbstractSTVPlatformConfig {
    constructor(params) {
        super(params);
        this.configs = this.utils.DeepMerge.deepmerge(this.configs, {
            properties: {
                device: EmbedDevice.SAMSUNG_SMART_TV
            },
            resourceConfig: {
                playback: {
                    preferredAudioCodecs: null
                }
            }
        });
    }
}
